import { EgpResponse } from '../egp.service';

import { Pipe, PipeTransform } from '@angular/core';

import moment from 'moment';

@Pipe({
  name: 'wDay',
  standalone: true,
})
export class WDayPipe implements PipeTransform {
  transform(egp: EgpResponse, day: number) {
    const from = egp.textObject.texts[day].validFrom;
    const to = egp.textObject.texts[day].validUntil;
    return [
      {
        from: moment(from).format('dd DD.MM.'),
        to: moment(to).format('dd DD.MM.YYYY'),
      },
      {
        from: moment(from).format('dd DD.MM.'),
        to: moment(to).format('dd DD.MM.YYYY'),
      },
      {
        from: moment(from).format('dd DD.MM.'),
        to: moment(to).format('dd DD.MM.YYYY'),
      },
      {
        from: moment(from).format('dd DD.MM.'),
        to: moment(to).format('dd DD.MM.YYYY'),
      },
      // if we wanna switch back ;)
      { from: moment(from).format('dddd'), to: moment(to).format('dddd') },
      { from: moment(from).format('dddd'), to: moment(to).format('dddd') },
      {
        from: moment(from).format('dddd DD.MM.'),
        to: moment(to).format('dddd DD.MM.YYYY'),
      },
    ];
  }
}
